import { ChevronDown, ToggleLeft } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/core/components/ui/dropdown-menu";
import type { AiSpreadsheetValueType } from "@/payroll/ai-script/types";
import { CELL_FORMAT_OPTIONS } from "./cell-format-options";
import { formatColumnLetter, VIEWER_OVERLAY_CLASSNAME } from "./utils";

const COLUMN_VALUE_TYPE_OPTIONS = [
  ...CELL_FORMAT_OPTIONS,
  {
    value: "boolean" as const,
    label: "Boolean",
    icon: <ToggleLeft className="h-3.5 w-3.5" />,
  },
];

interface ColumnValueTypeControlProps {
  columnIndex: number;
  disabled: boolean;
  onValueTypeChange: (
    column: number,
    valueType: AiSpreadsheetValueType,
  ) => void;
}

export const ColumnValueTypeControl = ({
  columnIndex,
  disabled,
  onValueTypeChange,
}: ColumnValueTypeControlProps) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <button
        type="button"
        disabled={disabled}
        aria-label={`Column ${formatColumnLetter(columnIndex)} value type`}
        className="flex shrink-0 items-center gap-1.5 border-l border-stroke-tertiary px-3 text-md text-secondary-text transition-colors hover:bg-surface-secondary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-40"
      >
        Column {formatColumnLetter(columnIndex)} type
        <ChevronDown className="h-3.5 w-3.5" />
      </button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className={VIEWER_OVERLAY_CLASSNAME}>
      {COLUMN_VALUE_TYPE_OPTIONS.map((option) => (
        <DropdownMenuItem
          key={option.value}
          disabled={disabled}
          className="gap-2"
          onSelect={() => onValueTypeChange(columnIndex + 1, option.value)}
        >
          {option.icon}
          {option.label}
        </DropdownMenuItem>
      ))}
    </DropdownMenuContent>
  </DropdownMenu>
);
